import axios from 'axios';

export const PERFORM_REQUEST = 'PERFORM_REQUEST';
export const PERFORM_REQUEST_SUCCESS = 'PERFORM_REQUEST_SUCCESS';
export const PERFORM_REQUEST_FAILURE = 'PERFORM_REQUEST_FAILURE';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_PAGE = 'SET_PAGE';
export const INIT_TRANSLATIONS = 'INIT_TRANSLATIONS';
export const INIT_LANGUAGE = 'INIT_LANGUAGE';
export const RESET_RESULTS = 'RESET_RESULTS';

export function performSearch() {
  return (dispatch, getState) => {
    dispatch({ type: PERFORM_REQUEST });
    return axios
        .get('/api/v1/contact/search', {
        params: {
          query: getState().query,
          lang: getState().language,
          page: getState().page - 1,
        },
      })
      .then(response => {
        dispatch({
          type: PERFORM_REQUEST_SUCCESS,
          data: response.data,
        });
      })
      .catch(error => {
        console.error('PERFORM_REQUEST_FAILURE', error);
        dispatch({ type: PERFORM_REQUEST_FAILURE });
      });
  };
}

export function setSearchQuery(query) {
  return {
    type: SET_SEARCH_QUERY,
    query,
  };
}

export function setPage(page) {
  return {
    type: SET_PAGE,
    page,
  };
}

export function initTranslations(translations) {
  return {
    type: INIT_TRANSLATIONS,
    translations,
  };
}

export function initLanguage(language) {
  return {
    type: INIT_LANGUAGE,
    language,
  };
}

export function resetResults() {
  return {
    type: RESET_RESULTS,
  };
}

